/**
 * Represents the type of the flow
 */
const FlowTypeEnum = {
  Csv: 0,
  Json: 1,
  Json_v2: 2,
};

export default FlowTypeEnum;
